import { BaseReducer } from '@hobs/utils/baseReducer';
import { FORSUBMIT, GET, CLEAR } from '@hobs/constants/units';

class Units extends BaseReducer {
  static defaultState = {
    unitsForSubmit: {
      unitTypes: [],
      unitOperationTypes: []
    },
    unit: null
  };

  constructor() {
    super(Units.defaultState);

    this.actionMap = {
      [FORSUBMIT.SUCCESS]: this.getUnitsForSubmit,
      [GET.SUCCESS]: this.getUnit,
      [CLEAR.SUCCESS]: this.clearUnit
    };
  }

  getUnitsForSubmit = (state, action) => {
    return Object.assign({}, state, {
      unitsForSubmit: action.response
    });
  };

  getUnit = (state, action) => {
    return Object.assign({}, state, {
      unit: action.payload
    })
  };

  clearUnit = state => {
    return Object.assign({}, state, { unit: null });
  };
}
export default new Units().reducer;
